var moduleName = "services.validate";

const $inject = [];

class ValidateService {
  constructor() {
  }

  medicare(medicare_number) {
    let valid = false;
    medicare_number = String(medicare_number).replace(/\D+/g, "");
    if (medicare_number.match(/^[2-6]\d{9}[1-6]?$/)) {
      const weights = [1, 3, 7, 9, 1, 3, 7, 9, 9];
      let checksum = 0;
      for (let i = 0; i < weights.length; ++i) {
        checksum += medicare_number[i] * weights[i];
      }
      valid = checksum % 10 === 0;
    }
    return valid;
  }
}

ValidateService.$inject = $inject;
//noinspection JSValidateTypes
export default angular.module(moduleName, [])
  .service("ValidateService", ValidateService)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/validate.service.js
 **/